import { styled } from '@mui/material/styles';
import React from 'react';
import { Box, BoxProps, Stack, StackProps } from '@mui/material';

export const SectionBox = styled(({ children, ...props }: BoxProps) => (
  <Box {...props}>{children}</Box>
))(() => ({
  padding: '24px 20px 40px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}));

export const PreviewBox = styled(({ children, ...props }: StackProps) => (
  <Stack {...props}>{children}</Stack>
))(() => ({
  padding: '12px',
  borderRadius: '8px',
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  gap: '6px',
}));
